import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const isTestEnv = process.env.NODE_ENV === 'test';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || (isTestEnv ? 'test-api-key' : undefined),
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || (isTestEnv ? 'test.firebaseapp.com' : undefined),
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || (isTestEnv ? 'test-project' : undefined),
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || (isTestEnv ? 'test-project.appspot.com' : undefined),
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || (isTestEnv ? '1234567890' : undefined),
  appId: process.env.REACT_APP_FIREBASE_APP_ID || (isTestEnv ? '1:1234567890:web:test' : undefined),
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];

if (!isTestEnv) {
  requiredKeys.forEach((key) => {
    if (!firebaseConfig[key]) {
      // Keep startup explicit so missing env does not fail silently.
      // eslint-disable-next-line no-console
      console.warn(`Missing Firebase config value: ${key}`);
    }
  });
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
